import { http } from './client';
import type { CacheConfigPatch, CacheConfigView } from './types';

export const cacheApi = {
  async get(botId: string): Promise<CacheConfigView> {
    const res = await http.get<CacheConfigView>(`/v1/org/bots/${encodeURIComponent(botId)}/cache`);
    return res.data;
  },
  async update(botId: string, patch: CacheConfigPatch): Promise<CacheConfigView> {
    const res = await http.put<CacheConfigView>(
      `/v1/org/bots/${encodeURIComponent(botId)}/cache`,
      patch,
    );
    return res.data;
  },
  async purge(botId: string): Promise<CacheConfigView> {
    const res = await http.post<CacheConfigView>(
      `/v1/org/bots/${encodeURIComponent(botId)}/cache/purge`,
    );
    return res.data;
  },
};
